<template>
  <div id="groups">
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
  <div style="margin: 15px 0;"></div>
    <CheckboxGroup v-model="checkedIds" style='width:100%;' @on-change="handleCheckedCitiesChange">
      <Checkbox v-for='item in items' :label="item.id" :key='item.id'  style='margin-right: 40px;'>
        {{item.name}}
      </Checkbox>
    </CheckboxGroup>
  </div>
</template>
<script>
  export default {
    props: [
      "checked",
    ],
    data() {
      return {
        checkAll: false,
        //选中的考勤组id
        checkedIds: [],
        isIndeterminate: true,
        items: [],
        //选中的考勤组名称
        checkedItemNames: [],
      };
    },
    methods: {
      handleCheckAllChange(isCheckedAll) {
        this.checkedIds = isCheckedAll ? this.items.map(item => {return item.id}) : [];
        this.isIndeterminate = false;
        this.setChecked(this.checkedIds)
      },
      handleCheckedCitiesChange(checkedIds) {
        let checkedCount = checkedIds.length;
        this.checkAll = checkedCount === this.items.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.items.length;
        this.setChecked(checkedIds);
      },
      setChecked(checkedIds) {
        let checkedItems = this.items.filter(item => {
          return checkedIds.indexOf(item.id) !== -1
        });
        this.checkedItemNames = checkedItems.map(checkedItem => {return checkedItem.name});
        this.$emit('setAttendance',checkedItems);
      },
      getAttendance() {
        this.$api.getAttendanceGroups({
          from: 1,
          size: 100,
          conditions: []
        }).then((res) => {
          this.$nextTick(()=>{
            this.items = res.records;
            this.checkedIds = this._props.checked && this._props.checked.map(attendance =>  attendance.id);
          })
        }).catch((error) => {
          this.$Message.error({
            content: error.response.data.detail,
            duration: 3
          });
        })
      }
    }
  };
 </script>
